import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import styles from "./Dropdown.module.scss";

interface DropdownProps {
    title: string;
    children: React.ReactNode;
    defaultOpen?: boolean;
    isOpen?: boolean;
    onToggle?: (isOpen: boolean) => void;
}

export const Dropdown: React.FC<DropdownProps> = ({ title, children, defaultOpen = false, isOpen, onToggle }) => {
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    const open = typeof isOpen === 'boolean' ? isOpen : internalOpen;

    useEffect(() => {
        if (typeof isOpen !== 'boolean') {
            setInternalOpen(defaultOpen);
        }
    }, [defaultOpen, isOpen]);

    const handleToggle = () => {
        const next = !open;
        if (typeof isOpen === 'boolean') {
            onToggle?.(next);
            return;
        }
        setInternalOpen(next);
        onToggle?.(next);
    };

    return (
        <div className={styles.dropdownContainer}>
            <div
                className={styles.dropdownHeader}
                onClick={handleToggle}
            >
                <span>{title}</span>
                <button
                    type="button"
                    className={styles.dropdownToggle}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleToggle();
                    }}
                    aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
                >
                    {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                </button>
            </div>

            <div
                className={`${styles.dropdownContent} ${open ? styles.open : ""}`}
            >
                {children}
            </div>
        </div>
    );
};
